import { MenuProps } from "antd";

export const navbarMenuItems: MenuProps["items"] = [
  {
    label: "Odjavi se",
    key: "logout",
  },
];
